<app-common-filter [list]="supplierList" textField='Description' [(filter)]="filter" [(isDirty)]="isDirty"
    identifier="shipment_filter_supplier" valueField="ShipperCustomerID">
</app-common-filter>